export const normalizeStoreTimeForInput = (value?: string | null) => {
  if (value === null || value === undefined || value.length === 0) return ''

  const normalizedValue = value.trim().toLowerCase()
  if (normalizedValue === 'noon') return '12:00'
  if (normalizedValue === 'midnight') return '00:00'

  const timeMatch = /(\d{1,2}):(\d{2})(?::\d{2})?/.exec(value)
  if (!timeMatch) return ''

  const hours = timeMatch[1]
  const minutes = timeMatch[2]
  if (hours === undefined || minutes === undefined) return ''

  return `${hours.padStart(2, '0')}:${minutes}`
}
